import client from 'data/client';
import { PrinterStatusData } from 'data/types/printerStatus';
import { normalizePrinterStatus } from 'model/pinterStatus';

const getPrinterStatus = async () => {
  const response = await client.get<PrinterStatusData>(`/printer/status`);
  return normalizePrinterStatus(response.data);
};

export default getPrinterStatus;
